import React from 'react';

import NavLinkItem from 'root/widgets/global-components/navbar/sub-components/common/nav-link-item';
import type { SideNavLinkListProps } from 'root/widgets/global-components/navbar/types';

const SideNavLinkList: React.FC<SideNavLinkListProps> = ({ context, navLinks, agentLinks, onLinkClick }) => {
  const handleNavLinkClick = (text: string) => {
    onLinkClick(text);
  };

  return (
    <div className="side-nav-link-list">
      {navLinks.length > 0 && (
        <div className="nav-link-list">
          {navLinks.map((link) => (
            <NavLinkItem
              key={link.text}
              context={context}
              isSelected={link.isSelected ?? false}
              isOnSideNav
              link={link}
              onClick={handleNavLinkClick}
            />
          ))}
        </div>
      )}

      {agentLinks && agentLinks?.items?.length > 0 && (
        <div className="agent-link-list">
          <p className="agent-link-list-title">{agentLinks?.title}</p>
          {agentLinks?.items.map((link) => (
            <NavLinkItem
              key={link.text}
              context={context}
              className="agent-link-item"
              link={link}
              isOnSideNav
              onClick={handleNavLinkClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SideNavLinkList;
